const c64Palette = {
  0:"#000000", // Black
  1:"#FFFFFF", // White
  2:"#A0292F", // Red
  3:"#59DCD4", // Cyan
  4:"#A82CB7", // Purple
  5:"#3FC033", // Green
  6:"#3e32a2", // Blue
  7:"#F4F941", // Yellow
  8:"#A84A14", // Orange
  9:"#643800", // Brown
 10:"#E56067", // Light Red
 11:"#4A4A4A", // Dark Grey
 12:"#7B7B7B", // Grey
 13:"#8FFF81", // Light Green
 14:"#7c71db", // Light Blue
 15:"#B2B2B2"  // Light Grey
};
    // 0: "#000000", // Black
    // 1: "#FFFFFF", // White
    // 2: "#813338", // Red
    // 3: "#75CEC8", // Cyan
    // 4: "#8E3C97", // Purple
    // 5: "#56AC4D", // Green
    // 6: "#2E2C9B", // Blue
    // 7: "#EDF171", // Yellow
    // 8: "#8E5029", // Orange
    // 9: "#553800", // Brown
    // 10: "#C46C71", // Light Red
    // 11: "#4A4A4A", // Dark Grey
    // 12: "#7B7B7B", // Grey
    // 13: "#A9FF9F", // Light Green
    // 14: "#706DEB", // Light Blue
    // 15: "#B2B2B2"  // Light Grey

export let DEFAULT_FG = c64Palette[14];
export let DEFAULT_BG = c64Palette[6];  

export const resetDefaultColors = () => {
  DEFAULT_FG = c64Palette[14];
  DEFAULT_BG = c64Palette[6];
};

export const setDefaultColors = (fg = c64Palette[14], bg = c64Palette[6]) => {
  DEFAULT_FG = fg;
  DEFAULT_BG = bg;
};

// Helper that maps simple color names to our C64 palette values.
// You can extend this mapping as needed.
export const parseColorValue = (value) => {
  const mapping = {
    black: c64Palette[0],
    white: c64Palette[1],
    red: c64Palette[2],
    cyan: c64Palette[3],
    purple: c64Palette[4],
    green: c64Palette[5],
    blue: c64Palette[6],
    yellow: c64Palette[7],
    orange: c64Palette[8],
    brown: c64Palette[9],
    "light red": c64Palette[10],
    lightred: c64Palette[10],
    "dark grey": c64Palette[11],
    darkgrey: c64Palette[11],
    grey: c64Palette[12],
    "light green": c64Palette[13],
    lightgreen: c64Palette[13],
    "light blue": c64Palette[14],
    lightblue: c64Palette[14],
    "light grey": c64Palette[15],
    lightgrey: c64Palette[15],
    "default_fg": DEFAULT_FG,
    "default_bg": DEFAULT_BG
  };

  return mapping[value.toLowerCase().trim()] || null;
};

export const getRandomColor = () => {
  const keys = Object.keys(c64Palette);
  const randomIndex = Math.floor(Math.random() * keys.length);
  return c64Palette[keys[randomIndex]];
}

export const getRandomColorExcept = (except) => {
  const keys = Object.keys(c64Palette).filter(key => c64Palette[key] !== except);
  const randomIndex = Math.floor(Math.random() * keys.length);
  return c64Palette[keys[randomIndex]];
}